let hueBase=0
const generateRandomColor = () => {
    const saturation = 70;
    const lightness = 50;

    hueBase = (hueBase + 137.5) % 360;
    return `hsl(${hueBase}, ${saturation}%, ${lightness}%)`;
}
export default generateRandomColor